import { render, staticRenderFns } from "./refund-succeed.vue?vue&type=template&id=54f564e4&scoped=true"
import script from "./refund-succeed.vue?vue&type=script&lang=js"
export * from "./refund-succeed.vue?vue&type=script&lang=js"
import style0 from "./refund-succeed.vue?vue&type=style&index=0&id=54f564e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f564e4",
  null
  
)

export default component.exports